// initial state
const state = {
  all: {},
  selected: ''
}

// getters
const getters = {
}

// actions
const actions = {
  
}

// mutations
const mutations = {
  setAll (state, all) {
    state.all = all
  },
  setSelected (state, selected) {
    state.selected = selected
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}